module.exports = __webpack_public_path__ + "img/add_box.9ccf0720.svg";